import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Elixir supports a subset of what our `}<a parentName="p" {...{
        "href": "/docs/api/flags"
      }}>{`feature flag API`}</a>{` provides.`}</p>
    <h4 {...{
      "id": "boolean-feature-flags"
    }}>{`Boolean feature flags`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`is_my_flag_enabled = Posthog.feature_flag_enabled?("flag-key", "distinct_id_of_your_user")

if is_my_flag_enabled
    # Do something differently for this user
    # Optional: fetch the payload
    {:ok, feature_flag} = Posthog.feature_flag("flag-key", "distinct_id_of_your_user")
end
`}</code></pre>
    <h4 {...{
      "id": "multivariate-feature-flags"
    }}>{`Multivariate feature flags`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`{:ok, feature_flag} = Posthog.feature_flag("flag-key", "distinct_id_of_your_user")
#  %Posthog.FeatureFlag{ name: "flag-key", payload: %{"variant-1" => "value-1", "variant-2" => "value-2"}, enabled: "variant-2" }

if feature_flag.enabled == 'variant-2' # replace 'variant-2' with the key of your variant
    # Do something differently for this user
end
`}</code></pre>
    <h4 {...{
      "id": "fetching-all-feature-flags"
    }}>{`Fetching all feature flags`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`Posthog.feature_flags("distinct_id_of_your_user")

{:ok,
 %{
   "featureFlagPayloads" => %{
     "feature-1" => 1,
     "feature-2" => %{"variant-1" => "value-1", "variant-2" => "value-2"}
   },
   "featureFlags" => %{"feature-1" => true, "feature-2" => "variant-2"}
 }}

`}</code></pre>
    <p>{`More documentation can be found in the `}<a parentName="p" {...{
        "href": "https://github.com/posthog/posthog-elixir"
      }}>{`repository`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      